import { render, staticRenderFns } from "./JoszakiTextAreaOld.vue?vue&type=template&id=b7ea8f48"
import script from "./JoszakiTextAreaOld.vue?vue&type=script&lang=js"
export * from "./JoszakiTextAreaOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports